import { render, staticRenderFns } from "./createRequestVendorInvoiceModal.vue?vue&type=template&id=31135da6&scoped=true&"
import script from "./createRequestVendorInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./createRequestVendorInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./createRequestVendorInvoiceModal.vue?vue&type=style&index=0&id=31135da6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31135da6",
  null
  
)

export default component.exports